import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import type { EntityCellProps } from '../../../../model/index.tsx';
import { getLocation } from '../../../../state/selectors/boards/index.tsx';
import type { State } from '../../../../state/types.tsx';
import Location from './view.tsx';

const mapStateToProps = () => (state: State, ownProps: EntityCellProps) => ({
	location: getLocation(state, ownProps.id),
});

export default connect(mapStateToProps, {})(Location);
